import ConversionFactoid from './component';

export default ConversionFactoid;
